<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddCreditorArticle"
      :is-valid="formValid"
      style="z-index:30002">
        <div  v-if="!isUploadOnly">
          <div>
            <QrCodeScannerDlg  ref="qrCodeScannerDlg" v-on:Scanned="qrCodeScanned"></QrCodeScannerDlg>
            <p>{{$t('ADD_CREDITOR.ARTICLE.HEADER.TEXT')}}</p>

            <vs-tabs v-model="activeTab">
              <vs-tab :label="$t('ADD_CREDITOR.ARTICLE.TAB.CREDITOR')">
                <vs-divider >{{$t('ADD_CREDITOR.ARTICLE.DIVIDER.NAME')}}</vs-divider>
                <div  class="default-input clearfix align-items-center mb-3">
                  <vs-input ref="name" :label="$t('ADD_CREDITOR.ARTICLE.LABEL.NAME')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.NAME')"  v-model="article.name" />
                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.NAME_SHORT')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.NAME_SHORT')"  v-model="article.name_short" />
                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.ARTICLE_NR_EXTERNAL')" class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.ARTICLE_NR_EXTERNAL')"  v-model="article.article_nr_external" />
                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.ORDER_NR')"  class="float-left inputx  mr-3 " :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.ORDER_NR')"  v-model="article.order_nr" />
                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.BARCODE')" v-on:icon-click="$refs.qrCodeScannerDlg.showDlg()" icon-after="true"  icon="camera_alt"  class="float-left inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.BARCODE')"  v-model="article.barcode" />
                </div>
                <vs-divider>{{$t('ADD_CREDITOR.ARTICLE.DIVIDER.UNITS')}}</vs-divider>
                <div class="default-input clearfix align-items-center mb-3">
                  <vs-select v-model="article.unit" class="float-left mr-3 inputx" :label="$t('ADD_CREDITOR.ARTICLE.LABEL.UNIT')">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in articleUnitForSelect" />
                  </vs-select>  
                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.NR_PER_UNIT')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.NR_PER_UNIT')"  v-model="article.nr_per_unit" />

                  <vs-input :label="$t('ADD_CREDITOR.ARTICLE.LABEL.PRICE_PER_UNIT')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_CREDITOR.ARTICLE.LABEL.PLACEHOLDER.PRICE_PER_UNIT')"  v-model="article.price_per_unit" />

                </div>
                <vs-textarea height="200px" counter="2500" :label="$t('ADD_CREDITOR.ARTICLE.LABEL.DESCRIPTION')" v-model="article.description" />            
              </vs-tab>         
              <vs-tab :label="$t('ADD_CREDITOR.ARTICLE.IMG')" :disabled="uploadDisabled">
                <div>
                  <div class="clearfix">
      
                      <vue-dropzone id="attachDrop" ref="attachDrop" 
                        :options="dropOptions" 
                        class="" 
                        v-on:vdropzone-success="dropzoneSuccess" 
                        v-on:vdropzone-error="dropzoneError" 
                        v-on:vdropzone-sending="dropzoneSending"
                        v-on:vdropzone-queue-complete="dropzoneQueueComplete"
                        v-on:vdropzone-file-added ="dropzoneFileAdded">
                      </vue-dropzone>
                  </div>
                  
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
          <div class="d-flex" v-if="isUploadOnly == false">
            <vs-button v-if="activeTab > 0 " class="mr-3" type="filled" icon="arrow_back_ios" @click="back()">{{$t('COM.BACK')}}</vs-button>
            <vs-button v-if="activeTab < idLastTab" type="filled" icon="arrow_forward_ios" @click="next()">{{$t('COM.NEXT')}}</vs-button>
          </div>

        </div>
        <div v-if="isUploadOnly">
           <vue-dropzone id="attachDrop" ref="attachDrop" 
              :options="dropOptions" 
              class="" 
              v-on:vdropzone-success="dropzoneSuccess" 
              v-on:vdropzone-error="dropzoneError" 
              v-on:vdropzone-sending="dropzoneSending"
              v-on:vdropzone-queue-complete="dropzoneQueueComplete"
              v-on:vdropzone-file-added ="dropzoneFileAdded">
            </vue-dropzone>
        </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';
import {articleUnit} from '../../../helper/enumHelper';
import vueDropzone from "vue2-dropzone";
import localStorageService from '../../../services/localstorage.service';
import QrCodeScannerDlg from './QrCodeScannerDlg.vue';

export default {
  name: "AddCreditorArticleDlg",
  components: {
    vueDropzone,
    QrCodeScannerDlg
  },
  props:[],
  data: function (){
     return {
       qrScanner:null,
       isUploadOnly: false,
       uploadDisabled:false,
       creditorId:0,
       dlgActive: false,
       activeTab: 0,
       idLastTab: 1,
       article:{},
       queuedFiles:[],
       popupTitle: this.$t('ADD_CREDITOR.ARTICLE.TITLE'),

        dropOptions: {
          url: this.$appConfig.apiBaseUrl+'/creditors/creditor/img/upload',
          maxFilesize: 15, // MB
          maxFiles: 1,
          chunking: false,
          chunkSize: 500, // Bytes
          thumbnailWidth: 100, // px
          thumbnailHeight: 100,
          addRemoveLinks: false,
          headers:{"Authorization":'Bearer ' + localStorageService.getAuthToken()},
          acceptedFiles:".jpg,.png,.bmp,.pdf,.doc,.docx,.xls,.xlsx",
          forceFallback:false,
          dictDefaultMessage:this.$t('DROPZONE.DEFAULTTEXT'),
          dictFallbackMessage: this.$t('DROPZONE.NOTSUPPORTED'),
          dictFallbackText: this.$t('DROPZONE.FALLBACK_TEXT'),
          dictFileTooBig:this.$t('DROPZONE.TOO_BIG'),
          dictInvalidFileType:this.$t('DROPZONE.INVALID_TYPE'),
          dictResponseError:this.$t('DROPZONE.RESPONSE_ERROR'),
          dictCancelUpload:this.$t('DROPZONE.CANCEL_UPLOAD'),
          dictUploadCanceled:this.$t('DROPZONE.UPLOAD_CANCELED'),
          dictCancelUploadConfirmation:this.$t('DROPZONE.CONFIRM_CANCEL'),
          dictRemoveFile:this.$t('DROPZONE.REMOVE_FILE'),
          dictRemoveFileConfirmation:this.$t('DROPZONE.CONFIRM_REMOVE_FILE'),
          dictMaxFilesExceeded:this.$t('DROPZONE.MAX_FILES'),
          autoProcessQueue:true
        },

     }
  }, 
  mounted () {
    this.$store.dispatch('numbergroup/getNumbergroupsByCompany',0,{ root: true });// Companyid des aktuellen users im backend ermitteln
    this.ClearForm();
    
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      getEmptyArticle(){
        let article = {
          article_nr:"",
          name:"",
          name_short:"",
          article_nr_external:"",
          barcode:"",
          pic_filename:"",
          unit:articleUnit.PIECE,
          nr_per_unit:1,
          price_per_unit:0,
          description:"",
          order_nr:"",
          available:true,
          locked:false,
          id:0,
          creditor_fk:this.creditorId

        };
        return article;
      },
      next(){
        this.activeTab += 1;
      },
      back(){
        this.activeTab -= 1;
      },
      showDlg(creditor){
        this.ClearForm();

        this.creditorId = creditor;
        this.article = this.getEmptyArticle();
        this.dlgActive=true;
        this.uploadDisabled=true;
        this.isUploadOnly = false;
      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data, creditor, uploadOnly){
        
        this.isUploadOnly = uploadOnly;

        if(this.IsNotNull(data))
        {

          this.article = data;
          this.creditorId = creditor;
          this.popupTitle = this.$t('ADD_CREDITOR.ARTICLE.TITLE.EDIT') + ' ('+this.article.article_nr+')';

          this.dlgActive=true;
        }
      },
      accepted(){

          var name = this.article.name + " ("+this.article.article_nr+")";
          this.$store.dispatch('creditor/saveCreditorArticle', this.article)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('ADD_CREDITOR.ARTICLE.SUCCESS.SAVE').replace("*1*",name)});  
            }
            else
            {
              var text = this.$t('ADD_CREDITOR.ARTICLE.WARNING.SAVE').replace("*1*",name);
              text = text.replace("*2*",this.$t(response.text));
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
            }
            this.$emit('Accepted',response.id);
          }, 
          error =>{
              var text = this.$t('ADD_CREDITOR.ARTICLE.ERROR.SAVE').replace("*1*",name);
              text = text.replace("*2*",error);
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':text});  
              this.$emit('Accepted');
          });
          
          this.ClearForm();
          this.$store.dispatch('creditor/getCreditorArticles', this.creditorId);
          
      },
      canceld(){
        this.ClearForm();
      },
      
      ClearForm(){

       this.article = this.getEmptyArticle();
        this.isUploadOnly = false;
        this.uploadDisabled = false;
        this.popupTitle = this.$t('ADD_CREDITOR.ARTICLE.TITLE');
      },
    dropzoneQueueComplete(){

      this.ClearFormAttachment();
    },
    dropzoneFileAdded(file){
      var qu = 
      {
        filename:file.upload.filename,
        uuid:file.upload.uuid,
        accepted:file.upload.accepted
      }
      this.queuedFiles.push(qu);
    },
        // eslint-disable-next-line no-unused-vars
    dropzoneSuccess(file, response){
      this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('DEBITORCONTACT.SUCCESS.UPLOAD_IMG').replace("*1*",file.upload.filename)});
      this.$refs.attachDrop.removeFile(file);
      
      if(this.isUploadOnly)
      {
        this.$emit('Accepted');
        this.dlgActive = false;
      }
      
    },
    // eslint-disable-next-line no-unused-vars
    dropzoneError(file, message, xhr){
      this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('DEBITORCONTACT.ERROR.UPLOAD_IMG').replace("*1*",file.upload.filename).replace("*2*",message)});
      this.$refs.attachDrop.removeFile(file);
    },
    // eslint-disable-next-line no-unused-vars
    dropzoneSending(file, xhr, formData) {
      formData.append('creditor_article_fk', this.article.id);
    },
    ClearFormAttachment(){ 

      this.$refs.attachDrop.removeAllFiles();
      this.queuedFiles = [];
    },
    qrCodeScanned(code)
    {
      this.article.barcode = code;

    },
    StartUpload()
    {
      this.$refs.attachDrop.processQueue();
    }
  },
  computed:{

    formValid(){
        return true;
    },
    articleUnitForSelect(){
      return this.GetArticleUnitForSelect();
    },
   
  },
  watch:{
    activeTab(value){
      switch(value)
      {
        case 0:
          this.$nextTick(() => this.setFocusOnInput('name'));
          break;        
      }
    }
  }
};
</script>
<style>
div#promptAddCreditorArticle > div.vs-dialog{
  max-width: 800px !important;
}
div#promptAddCreditorArticle > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}
</style>